export const source = {
  '1': '婚礼纪私信',
  '2': '预约',
  '3': '手动录入',
  '4': '领取优惠卷',
  '6': '婚礼纪活动',
  '7': '聚客宝活动',
  '8': '来自外部活动',
  '9': '婚礼策划报价',
  '10': '旅拍定制服务',
  '11': '婚纱摄影报价',
  '12': '礼服搭配服务',
  '100': '批量导入'
}

// 加盟店日程时间表类型
export const JIAMENG_SCHEDULE_MONTHLY = 'month'
export const JIAMENG_SCHEDULE_YEARLY = 'year'
